import { PolicyChangeAction } from 'core/helpers/policy-status';
import { localToUtcTime } from '../dates';
import { endDateValue } from './end-date-value';

export const getScreenAction = ({
  cancel,
  fullTermCancel,
  transactionDate,
  storedEndDate,
  fullTermPolicyEndDate,
  state
}) => {
  const endDateShortened =
    localToUtcTime(`${storedEndDate}T23:59:59.99`, state) <
    localToUtcTime(`${fullTermPolicyEndDate}T23:59:59.99`, state);
  if (cancel || fullTermCancel || transactionDate || endDateShortened) {
    return PolicyChangeAction.Cancel;
  }
  return undefined;
};

/** Screen action for the Settings form values — what the footer offers and what the form validates for. */
export const screenActionFor = (values) =>
  getScreenAction({
    cancel: values.cancel,
    fullTermCancel: values.fullTermCancel,
    transactionDate: values.transactionDate,
    storedEndDate: endDateValue(values),
    fullTermPolicyEndDate: values.fullTermPolicyEndDate,
    state: values.state
  });

export const POLICY_CHANGE_ACTION_FOOTER_LABEL = {
  [PolicyChangeAction.Reinstate]: 'Reinstate Policy',
  [PolicyChangeAction.Rescind]: 'Rescind Cancellation',
  [PolicyChangeAction.Cancel]: 'Cancel Policy'
};
